module.exports = __webpack_public_path__ + "../css/layout.css";